import { isPresent } from '@grandvisionhq/utils';

const getFaceShapes = (faceShape)=>{
    var ref;
    return (ref = faceShape.map(({ shape  })=>{
        return shape === null || shape === void 0 ? void 0 : shape.toLocaleLowerCase();
    })) === null || ref === void 0 ? void 0 : ref.filter(isPresent);
};

export { getFaceShapes };
//# sourceMappingURL=get-face-shapes.js.map
